/**
 * div 共性属性和方法
 * @type {string[]}
 */

// 默认在父子间继承的属性
const extendsProps = ['disable', 'isEdit', 'hidden']
export default {
  props: {
    w: { type: [String, Number], default: 220 }, // 宽度width
    h: [String, Number], // 高度height
    // placeholder: null,
    disabled: null, // 是否置灰(灰不可编辑)
    isEdit: null, // 编辑模式 或 展示模式(不灰不可编辑)
    hidden: null,
    value: null,
    size: null
    // style: null,
  },
  data() {
    return {}
  },
  created() {
  },
  mounted() {
    // 若未定义的属性，直接继承父组件的属性（便于，父组件隐藏统一隐藏子组件）
    for (const key in extendsProps) {
      const value = this[key]
      if (value == null) {
        if (this.$parent) {
          this[key] = this.$parent[key]
        }
      }
    }
  },
  computed: {
    getStyle() {
      let style = ''
      if (this.w && this.w !== 'auto') {
        style += 'width:' + this.w + 'px;'
      }
      if (this.h) {
        style += 'height:' + this.h + 'px;'
      }
      return style === '' ? null : style
    },
    computedIsEdit() {
      return this.computedProp('is-edit', 'boolean', true, 'isEdit')
    },
    computedSize() {
      return this.computedProp('size', 'string', null)
    }
  },
  methods: {
    computedProp(prop, propFieldType, defaultValue, prop2) {
      let propValue = this[prop]
      if (propValue == null && prop2) {
        propValue = this[prop2]
      }
      // console.log('computedProp|'+prop+'|'+propValue)
      if (propValue == null) {
        let parentPropValue = null
        let parent = this
        do {
          // 获取上层的prop属性
          parentPropValue = parent.$attrs[prop]
          if (parentPropValue == null && parent._props) {
            parentPropValue = parent._props[prop]
          }
          parent = parent.$parent
          propValue = parentPropValue
        } while (parent && (propValue == null || propFieldType !== typeof parentPropValue))
      }
      if (propValue == null) {
        propValue = defaultValue
      }
      return propValue
    }
  }
}
